import { initializeApp } from "firebase/app";
import { getFirestore } from "@firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyDtBgjjA9x56BeijtiC88Gi7OblBaLGcH0",
    authDomain: "fireup-da7fe.firebaseapp.com",
    projectId: "fireup-da7fe",
    storageBucket: "fireup-da7fe.appspot.com",
    messagingSenderId: "494253249584",
    appId: "1:494253249584:web:50ff76488ddae3e4dec9f5",
    measurementId: "G-WZFFYLEJ9Z"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
